import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import { dashboardQueryOptions } from './dashboard-query-options';

export interface GetPaymentHealthResponse {
  month: string;
  year: number;
  success: number;
  failure: number;
  refunded: number;
}

export interface GetPaymentHealthParams {
  sessionId: string;
  startDate: string; // yyyy-mm-dd
  endDate: string; // yyyy-mm-dd
}

export const getPaymentHealthAPI = async ({
  sessionId,
  startDate,
  endDate,
}: GetPaymentHealthParams) => {
  const response = await baseAPI.get<Array<GetPaymentHealthResponse>>(
    '/dashboard/metrics/payment-health',
    {
      params: {
        sessionId,
        startDate,
        endDate,
      },
    },
  );
  return response.data;
};

export const useGetPaymentHealth = (params: GetPaymentHealthParams) => {
  return useQuery({
    ...dashboardQueryOptions,
    queryKey: [
      KEYS.PAYMENT_HEALTH,
      params.sessionId,
      params.startDate,
      params.endDate,
    ],
    queryFn: () => getPaymentHealthAPI(params),
    enabled: !!params.sessionId && !!params.startDate && !!params.endDate,
  });
};
